var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.FontAwesomeIcon,{staticClass:"mr-1",attrs:{"icon":_setup.stepIcon}})
}
var staticRenderFns = []

export { render, staticRenderFns }